import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EditorText=({className="custom-quill-editor",value,setValue})=>{
  return <ReactQuill className={className}  theme="snow" value={value} onChange={setValue} />;
}

export default EditorText;